<div *ngIf="loading" class="loading-text">
  <p>{{ 'PleaseWaitDataLoading' | translate }}</p>
</div>

<div *ngIf="!loading">
<app-sub-header [pageTitle]="'Region' | translate"></app-sub-header>

<div class="padded-container" *ngIf="regionResponse?.regionList">
    <div *ngFor="let regionItem of regionResponse?.regionList">
      <dx-button
        class="full-width-button"
        text="{{ regionItem.description }}"
        type="default"
        (onClick)="continueNextStep(regionItem.regionId)">
      </dx-button>
    </div>
  <dx-button
    class="full-width-button"
    text="{{ 'Continue' | translate }}"
    type="default"
    (onClick)="navigateToPickClient()">
  </dx-button>
</div>
</div>